<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h2>用户登录</h2>
        <p>欢迎回来，请登录您的账号</p>
      </div>

      <form class="login-form" @submit.prevent="handleLogin">
        <div class="form-item">
          <div class="input-wrapper">
            <span class="icon">📱</span>
            <input
              id="phone"
              v-model="formData.phone"
              type="tel"
              placeholder="请输入手机号"
              maxlength="11"
              @blur="validatePhone"
            />
          </div>
          <span v-if="errors.phone" class="error-text">{{ errors.phone }}</span>
        </div>

        <div class="form-item">
          <div class="input-wrapper captcha-wrapper">
            <span class="icon">🔐</span>
            <input
              id="captcha"
              v-model="formData.captcha"
              type="text"
              placeholder="请输入验证码"
              maxlength="4"
            />
            <canvas
              ref="captchaCanvas"
              class="captcha-img"
              @click="refreshCaptcha"
              title="点击刷新验证码"
            ></canvas>
          </div>
          <span v-if="errors.captcha" class="error-text">{{ errors.captcha }}</span>
        </div>

        <button type="submit" class="login-btn" :disabled="isSubmitting">
          <span v-if="!isSubmitting">登录</span>
          <span v-else class="loading">登录中...</span>
        </button>
      </form>

      <!-- 登录失败弹框 -->
      <div v-if="showErrorModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h3>❌ 登录失败</h3>
            <button class="close-btn" @click="closeErrorModal">✕</button>
          </div>
          <div class="modal-body">
            <p style="text-align: center; color: #666; margin: 0;">{{ errorMessage }}</p>
            <p style="text-align: center; color: #999; margin: 10px 0 0 0; font-size: 12px;">3秒后自动关闭</p>
          </div>
          <div class="modal-footer">
            <button class="confirm-btn" @click="closeErrorModal">确定</button>
          </div>
        </div>
      </div>

      <!-- <div class="login-footer">
        <a href="#" class="link">忘记密码？</a>
        <a href="#" class="link">注册账号</a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      formData: {
        phone: '',
        captcha: ''
      },
      errors: {
        phone: '',
        captcha: ''
      },
      captchaCode: '',
      isSubmitting: false,
      showErrorModal: false,
      errorMessage: '',
      errorModalTimer: null
    }
  },
  mounted() {// 设置浏览器页面标题
    document.title = '河马剧场热门权益'
    this.refreshCaptcha()
  },
  methods: {
    // 生成随机验证码
    generateCode() {
      const chars = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ'
      let code = ''
      for (let i = 0; i < 4; i++) {
        code += chars[Math.floor(Math.random() * chars.length)]
      }
      return code
    },

    // 刷新验证码
    refreshCaptcha() {
      this.captchaCode = this.generateCode()
      this.drawCaptcha()
    },

    // 绘制验证码图片
    drawCaptcha() {
      const canvas = this.$refs.captchaCanvas
      if (!canvas) return

      const ctx = canvas.getContext('2d')
      const width = 120
      const height = 40

      canvas.width = width
      canvas.height = height

      // 绘制背景
      ctx.fillStyle = '#f5f5f5'
      ctx.fillRect(0, 0, width, height)

      // 绘制干扰线
      for (let i = 0; i < 4; i++) {
        ctx.beginPath()
        ctx.moveTo(Math.random() * width, Math.random() * height)
        ctx.lineTo(Math.random() * width, Math.random() * height)
        ctx.strokeStyle = this.randomColor(100, 200)
        ctx.lineWidth = 1
        ctx.stroke()
      }

      // 绘制干扰点
      for (let i = 0; i < 20; i++) {
        ctx.beginPath()
        ctx.arc(Math.random() * width, Math.random() * height, 1, 0, 2 * Math.PI)
        ctx.fillStyle = this.randomColor(150, 255)
        ctx.fill()
      }

      // 绘制验证码文字
      const codeChars = this.captchaCode.split('')
      codeChars.forEach((char, index) => {
        ctx.font = `${18 + Math.random() * 4}px Arial`
        ctx.fillStyle = this.randomColor(50, 150)
        ctx.textBaseline = 'middle'
        const x = (width / 4) * index + 8 + Math.random() * 4
        const y = height / 2 + Math.random() * 4
        ctx.fillText(char, x, y)
      })
    },

    // 生成随机颜色
    randomColor(min, max) {
      const r = Math.floor(Math.random() * (max - min) + min)
      const g = Math.floor(Math.random() * (max - min) + min)
      const b = Math.floor(Math.random() * (max - min) + min)
      return `rgb(${r}, ${g}, ${b})`
    },

    // 验证手机号
    validatePhone() {
      const phone = this.formData.phone
      if (!phone) {
        this.errors.phone = '请输入手机号'
      } else if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.errors.phone = '请输入正确的手机号'
      } else {
        this.errors.phone = ''
      }
    },

    // 验证表单
    validateForm() {
      let isValid = true

      // 验证手机号
      this.validatePhone()
      if (this.errors.phone) {
        isValid = false
      }

      // 验证验证码
      if (!this.formData.captcha) {
        this.errors.captcha = '请输入验证码'
        isValid = false
      } else if (this.formData.captcha.length < 4) {
        this.errors.captcha = '验证码必须为4位'
        isValid = false
      } else if (this.formData.captcha.toUpperCase() !== this.captchaCode) {
        this.errors.captcha = '验证码错误'
        this.refreshCaptcha()
        this.formData.captcha = ''
        isValid = false
      } else {
        this.errors.captcha = ''
      }

      return isValid
    },

    // 处理登录
    async handleLogin() {
      if (!this.validateForm()) {
        return
      }

      this.isSubmitting = true

      try {
        // 调用登录接口
        const response = await fetch('https://api.goquanyi.com/bwqy/web/apiOpen/v1/phoneLogin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userPhone: this.formData.phone
          })
        })

        const data = await response.json()
        console.log('登录信息',data)
        if (data.result.code === '0000') {
          // 登录成功，保存用户信息到本地存储
          const zjz001 = data.result.zjz001
          if (zjz001) {
            localStorage.setItem('userAccNo', zjz001)
          }

          // 保存用户名称和手机号
          if (data.result.name) {
            localStorage.setItem('userName', data.result.name)
          }
          if (data.result.phone) {
            localStorage.setItem('userPhone', data.result.phone)
          }

          // 记录登录时间（毫秒级时间戳）
          localStorage.setItem('loginTime', Date.now().toString())

          // 跳转到个人信息页面
          this.$router.push('/person')

          // 重置表单
          this.formData = {phone: '', captcha: ''}
          this.refreshCaptcha()
        } else {
          // 登录失败，显示错误提示弹框
          this.errorMessage = data.result.msg || '该账户不允许登录，请重试'
          this.showErrorModal = true
          this.startErrorModalTimer()
        }
      } catch (error) {
        this.errorMessage = '登录失败，请重试'
        this.showErrorModal = true
        this.startErrorModalTimer()
      } finally {
        this.isSubmitting = false
      }
    },
    // 启动错误弹框自动关闭定时器
    startErrorModalTimer () {
      // 清除之前的定时器
      if (this.errorModalTimer) {
        clearTimeout(this.errorModalTimer)
      }
      // 3秒后自动关闭
      this.errorModalTimer = setTimeout(() => {
        this.showErrorModal = false
        this.errorModalTimer = null
      }, 3000)
    },
    // 关闭错误弹框
    closeErrorModal () {
      if (this.errorModalTimer) {
        clearTimeout(this.errorModalTimer)
        this.errorModalTimer = null
      }
      this.showErrorModal = false
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 93vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.login-header p {
  margin: 0;
  color: #999;
  font-size: 14px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper .icon {
  position: absolute;
  left: 14px;
  font-size: 18px;
  color: #999;
}

.input-wrapper input {
  width: 100%;
  padding: 14px 14px 14px 45px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.input-wrapper input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-wrapper input::placeholder {
  color: #ccc;
}

.captcha-wrapper {
  gap: 10px;
}

.captcha-wrapper input {
  flex: 1;
  padding-right: 14px;
}

.captcha-img {
  width: 120px;
  height: 44px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease;
}

.captcha-img:hover {
  transform: scale(1.02);
}

.error-text {
  font-size: 12px;
  color: #ff4757;
  text-align: left;
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading {
  display: inline-flex;
  align-items: center;
}

.loading::after {
  content: '';
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  margin-left: 8px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 弹框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  color: #999;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #eee;
  color: #666;
}

.modal-body {
  padding: 20px 24px;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
}

.confirm-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue